module.exports = __webpack_public_path__ + "img/olesya-dobryakova.72364d80.jpg";